import React from 'react';
import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
import { Line } from 'react-chartjs-2';

export function TotalProtocolsOpenOverTime({ protocolData }) {
  const options = {
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 3
        }
      }
    }
  };

  return (
    <Row>
      <Col xl="12">
        <Card>
          <CardHeader>
            <h5 className="h3 mb-0">Protocolos em aberto por dia</h5>
          </CardHeader>
          <CardBody>
            <div className="chart">
              <Line
                data={protocolData.data}
                options={options}
                className="chart-canvas"
                id="chart-bars"
              />
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}
